import axios from 'axios';
import config from 'config.js';

// Constants
const GET_SCAM_KEYWORDS_REQUEST = 'scam/GET_SCAM_KEYWORDS_REQUEST';
const GET_SCAM_KEYWORDS_SUCCESS = 'scam/GET_SCAM_KEYWORDS_SUCCESS';
const GET_SCAM_KEYWORDS_FAILURE = 'scam/GET_SCAM_KEYWORDS_FAILURE';

const UPDATE_SCAM_KEYWORDS_REQUEST = 'scam/UPDATE_SCAM_KEYWORDS_REQUEST';
const UPDATE_SCAM_KEYWORDS_SUCCESS = 'scam/UPDATE_SCAM_KEYWORDS_SUCCESS';
const UPDATE_SCAM_KEYWORDS_FAILURE = 'scam/UPDATE_SCAM_KEYWORDS_FAILURE';

const GET_POTENTIAL_SCAM_REQUEST = 'scam/GET_POTENTIAL_SCAM_REQUEST';
const GET_POTENTIAL_SCAM_SUCCESS = 'scam/GET_POTENTIAL_SCAM_SUCCESS';
const GET_POTENTIAL_SCAM_FAILURE = 'scam/GET_POTENTIAL_SCAM_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  scamKeywords: null,
  scamForms: [],

  getScamKeywords: { ...endpoitInitialStatus },
  updateScamKeywords: { ...endpoitInitialStatus },
  getPotentialScamForms: { ...endpoitInitialStatus },
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === GET_SCAM_KEYWORDS_REQUEST) {
    state.getScamKeywords = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_SCAM_KEYWORDS_SUCCESS) {
    state.getScamKeywords = getEndpointStatus('success');
    state.scamKeywords = action.payload;

    return { ...state };
  }

  if (action.type === GET_SCAM_KEYWORDS_FAILURE) {
    state.getScamKeywords = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_POTENTIAL_SCAM_REQUEST) {
    state.getScamKeywords = getPotentialScamForms('request');

    return { ...state };
  }

  if (action.type === GET_POTENTIAL_SCAM_SUCCESS) {
    state.getScamKeywords = getPotentialScamForms('success');
    state.scamForms = action.payload;

    return { ...state };
  }

  if (action.type === GET_POTENTIAL_SCAM_FAILURE) {
    state.getScamKeywords = getPotentialScamForms('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getScamKeywords() {
  const request = () => { return { type: GET_SCAM_KEYWORDS_REQUEST } };
  const success = (res) => { return { type: GET_SCAM_KEYWORDS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_SCAM_KEYWORDS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getScamKeywords();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getPotentialScamForms() {
  const request = () => { return { type: GET_POTENTIAL_SCAM_REQUEST } };
  const success = (res) => { return { type: GET_POTENTIAL_SCAM_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_POTENTIAL_SCAM_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getPotentialScamForms();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function updateScamKeywords(keywords) {
  const request = () => { return { type: UPDATE_SCAM_KEYWORDS_REQUEST } };
  const success = (res) => { return { type: UPDATE_SCAM_KEYWORDS_SUCCESS, payload: res } };
  const failure = () => { return { type: UPDATE_SCAM_KEYWORDS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.updateScamKeywords({ keywords });

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getPotentialScamForms: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/scam/forms`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getScamKeywords: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/scam/keywords`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  updateScamKeywords: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/scam/keywords`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
};
